export default ({
  pageState: { editorBlocks, editorBlocksOrder },
  data: { blockIds, updatedAt }
}) => {
  return {
    editorBlocks: Object.keys(editorBlocks).reduce((blocks, id) => {
      if (!blockIds.includes(id)) blocks[id] = editorBlocks[id];
      return blocks;
    }, {}),
    editorBlocksOrder: editorBlocksOrder.filter(id => !blockIds.includes(id)),
    editorHeaderStatus: 'saved',
    editorHeaderUpdatedAt: updatedAt,
    editorIsDraft: true
  }; 
};
